// export function linkify (text: string) {
//   var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
//   return text.replace(urlRegex, function (url) {
//     return '<a href="' + url + '">' + url + '</a>'
//     return url
//   })
// }

export function normalizeUrl(text: string): string {
  const trimmed = text.trim();
  if (!trimmed) return trimmed;

  // Already has a valid protocol — leave it as-is
  if (/^(https?|ftp|file):\/\//i.test(trimmed)) return trimmed;

  // Starts with "www." — add https://
  if (/^www\./i.test(trimmed)) return `https://${trimmed}`;

  // Looks like a domain/URL (contains a dot, no spaces) — add https://www.
  if (/^[^\s]+\.[^\s]+$/.test(trimmed)) return `https://www.${trimmed}`;

  return trimmed;
}

export function linkify(text: string): string {
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  let link = "";
  text.replace(urlRegex, function (url) {
    link = url;
    return '<a href="' + url + '">' + url + "</a>";
  });
  return link;
}
